export class EnquiryIdreq{
    enquiryid:number
    productContainerGroup?:number
    operation?: string
    constructor(
        enquiryId:number,
        productContainerGroup?:number,
        operation?: string
    )
   {
    this.enquiryid=enquiryId
    this.productContainerGroup = productContainerGroup
    this.operation = operation
   }
}